module.exports = __webpack_public_path__ + "static/portrait_jessica-602d83d7ab76013ab5943d32563787d6.png";